import React, { useContext, useEffect } from 'react'
import cookie from 'react-cookies'
import {
  Form,
  Button,
  Radio,
  Switch,
  Checkbox,
  Table,
  InputNumber,
  Upload,
  Input,
  Cascader,
  Spin,
  Space,
  TimePicker,
  DatePicker as PcDatePicker,
} from 'antd'
import { LoadingOutlined, UploadOutlined } from '@ant-design/icons'
import {
  Picker,
  List,
  Toast,
  Drawer,
  DatePicker,
  Modal,
  TextareaItem,
} from 'antd-mobile'
import { withCookies } from 'react-cookie'
import moment from 'moment'
import Zmage from 'react-zmage'
import $ from 'jquery'

import styles from './form.module.css'
import {
  _getForm,
  _saveForm,
  _getDataForm,
  _loginByCode,
  _refreshFieldValue,
  _uploadByWx,
  _ocrVatInvoice,
} from '../../server'
import { SelectMember, SelectFormData, SelectSourceData } from '../MyModals'
import { InvoiceComponent } from '../MyComs'
import {
  convertCurrency,
  genId,
  getWxSignature,
  isQiyeweixinApp,
  isMacQiyeweixin,
  isIOS,
  previewFileByOW365,
  getFirstWord,
} from '../ShareUtils'
import {
  _onNumberChange,
  _setFormFieldVisibleStatus,
  _formatTDText,
  _checkChildFormInputValue,
  _randomString,
  _getDownloadPath,
  _getStatisticsValue,
  _getEquationFieldValue,
  _updateFormFieldDefaultValue,
  _formatFormField,
  _getFormatEquation,
} from '../CommonUtils'

const ALI_OSS_DOWNLOAD = process.env.ALI_OSS_DOWNLOAD

const CheckboxGroup = Checkbox.Group
const alert = Modal.alert

const validateMessages = {
  required: '${label} is required!',
  types: {
    email: '输入的格式不正确!',
    number: '输入的格式不正确!',
  },
  number: {
    range: '${label} must be between ${min} and ${max}',
  },
}

class FormMainPage extends React.Component {
  mainFormRef = React.createRef()
  childFormRef = React.createRef()

  constructor(props) {
    super(props)
    this.state = {
      isLoading: true,
      formDetailShow: false,
      toaForm: {},
      formFields: [],
      selectedData: [],
      selectedExtra: {},
      transactorCC: [],
      submittingFormData: false,
      childFormDrawerOpen: false,
      currentFormField: { childFormFields: [] },
      preFormField: '',
      currentRow: -1,
      preRowIndex: -1,
      selectDepart: false,
      userDepartList: [],
      userDepart: 0,
      hasError: false,
      fileList: [],
      userid: '',
      username: '',
      formDataId: '',
      code: '',
      formRules: [],
      actionType: 2,
      jsapiticket: '',
      timestamp: moment().format('X'),
      appId: '',
      nonceStr: genId(),
      limitStr: '',
      definitionId: '',
      nodePermissions: '',
      fullScreenChild: '',
      removeFileList: [],
      lastRecognizedList: [],
      formSetting: '',
      isDraft: false,
    }
    const { cookies } = this.props
    this.sid = cookies.get(process.env.TOKEN_KEY)

    if (
      !this.props.location.query ||
      (!this.props.location.query.formId &&
        !this.props.location.query.formDataId)
    ) {
      if (window.location.search) {
        let strSearch = window.location.search
        let params = strSearch.substring(1, strSearch.length).split('&')
        if (params) {
          params.map((item, i) =>
            item.split('=')[0] === 'formDataId'
              ? (this.state.formDataId = item.split('=')[1])
              : ''
          )
          params.map((item, i) =>
            item.split('=')[0] === 'code'
              ? (this.state.code = item.split('=')[1])
              : ''
          )
        }
      }
      if (!this.state.formDataId) {
        this.props.history.push('/')
      } else {
        this.state.isDraft = true
        this.getDataForm()
      }
    } else {
      if (!this.props.location.query.formDataId) {
        this.getForm()
      } else {
        this.state.formDataId = this.props.location.query.formDataId
        this.state.isDraft = this.props.location.query.draft
        this.getDataForm()
      }
    }
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true })
  }

  bindSelectMemberRef = (ref) => {
    this.selectMemberModal = ref
  }

  bindSelectFormDataRef = (ref) => {
    this.selectFormDataModal = ref
  }

  bindSelectSourceDataRef = (ref) => {
    this.selectSourceDataModal = ref
  }

  updateSelectedData = (extra, list) => {
    switch (extra.type) {
      case 1:
        //相关人
        this.setState({ transactorCC: list })
        break
      case 2:
        //人员控件
        if (extra.data.parentId) {
          for (
            var i = 0;
            i < this.state.currentFormField.childFormFields.length;
            i++
          ) {
            if (
              this.state.currentFormField.childFormFields[i].fieldId ===
              extra.data.fieldId
            ) {
              this.state.currentFormField.childFormFields[i].inputValue = list
              break
            }
          }
          this.setState({ currentFormField: this.state.currentFormField })
        } else {
          this.state.formFields.map((item) =>
            item.fieldId === extra.data.fieldId ? (item.inputValue = list) : ''
          )
          this.setState({ formFields: this.state.formFields })
          for (var i = 0; i < this.state.formFields.length; i++) {
            var formField = this.state.formFields[i]
            if (
              formField.fieldType === 'RadioButton' &&
              formField.moreSetting &&
              formField.moreSetting.dataSourceUrl &&
              formField.moreSetting.dataSourceUrl.indexOf(
                '${' + extra.data.fieldId + '}'
              ) > 0
            ) {
              this.refreshFieldValue(formField.fieldId, [extra.data])
            }
          }
        }
        break
      case 100:
        extra.data.inputValue = list
        extra.data.preInputValue = JSON.parse(JSON.stringify(list))
        this.updateFormField(extra.data)
        break
      case 200:
        //数据源
        extra.data.inputValue = list
        this.updateFormField(extra.data)
        break
      default:
        break
    }
  }

  async refreshFieldValue(fieldId, reqParams) {
    const res = await _refreshFieldValue(
      this.sid,
      this.state.toaForm.formId,
      fieldId,
      this.state.userDepart,
      reqParams
    )
    if (res.code === 0) {
      for (var i = 0; i < this.state.formFields.length; i++) {
        if (this.state.formFields[i].fieldId === fieldId) {
          this.state.formFields[i].multipleValue = res.data.values
          if (res.data.values && res.data.values.length > 0) {
            this.state.formFields[i].inputValue = [res.data.values[0].name]
            this.setState({ formFields: this.state.formFields })
          }
          break
        }
      }
    }
  }

  _refreshDataSource() {
    this.state.formFields.map((item) => {
      if (item.fieldType === 'StaffField') {
        if (item.inputValue.length === 0 && item.defaultValueType === 3) {
          item.inputValue = [
            { name: this.state.username, userid: this.state.userid },
          ]
        }
        for (var i = 0; i < this.state.formFields.length; i++) {
          var formField = this.state.formFields[i]
          if (
            formField.fieldType === 'RadioButton' &&
            formField.moreSetting &&
            formField.moreSetting.dataSourceUrl &&
            formField.moreSetting.dataSourceUrl.indexOf(
              '${' + item.fieldId + '}'
            ) > 0
          ) {
            this.refreshFieldValue(formField.fieldId, [item])
          }
        }
      }
    })
    this.setState({ formFields: this.state.formFields })
  }

  _initInputValue(item) {
    if (item.selectedValue) {
      item.inputValue = [item.selectedValue]
    } else if (item.defaultValueType === 1 && item.defaultValue) {
      //切换TextareaItem
      //item.defaultValue = item.defaultValue.replace(/(\r\n|\n|\r)/gm, "<br>");
      item.inputValue = [item.defaultValue]
    } else if (item.defaultValueType === 5 && item.defaultValue) {
      item.inputValue = JSON.parse(item.defaultValue)
    }

    if (item.multipleValue) {
      item.multipleValue.map((subItem) => {
        if (subItem.isSelected) {
          item.inputValue.splice(item.inputValue.length, 0, subItem.name)
        }
      })
    }

    return item
  }

  _initFormFields(formFields) {
    formFields.map((item) => {
      item = this._initInputValue(_formatFormField(item))
      if (item.fieldType === 'ChildField') {
        item.childFormFields.map((subItem) => {
          subItem = this._initInputValue(_formatFormField(subItem))
        })
      } else if (item.fieldType === 'FORMREFCustomerField') {
        item.childFormFields.map((subItem) => {
          subItem = _formatFormField(subItem)
          if (subItem.fieldType === 'ChildField') {
            subItem.childFormFields.map((sonItem) => {
              sonItem = _formatFormField(sonItem)
            })
          }
        })
      }
    })

    return formFields
  }

  async getForm() {
    const res = await _getForm(this.sid, this.props.location.query.formId)
    if (res.code === 0) {
      this.setState({
        toaForm: res.data.toaForm,
        lastCC: res.data.lastCC,
        fileList: res.data.fileList,
        userid: res.data.userid,
        username: res.data.username,
        formRules: res.data.formRules,
        definitionId: res.data.toaForm.definitionId,
      })

      res.data.formFields = this._initFormFields(res.data.formFields)
      var cacheFormFields = window.localStorage.getItem(
        this.state.toaForm.formId + '_formFields'
      )
      if (cacheFormFields) {
        cacheFormFields = JSON.parse(cacheFormFields)
        for (var i = 0; i < cacheFormFields.length; i++) {
          for (var j = 0; j < res.data.formFields.length; j++) {
            if (res.data.formFields[j].fieldId === cacheFormFields[i].fieldId) {
              if (cacheFormFields[i].fieldName === '数据源') {
                cacheFormFields[i] = res.data.formFields[j]
              } else if (cacheFormFields[i].fieldType === 'ChildField') {
                //TODO ChildField中数据源控件
              }
              break
            }
          }
        }
        alert('提示', '是否需要加载上次编辑内容', [
          {
            text: '取消',
            onPress: () => {
              window.localStorage.setItem(
                this.state.toaForm.formId + '_formFields',
                ''
              )
              this.setState(
                {
                  formFields: this.setFormFieldVisibleStatus(
                    res.data.formFields
                  ),
                },
                () => setTimeout(this._refreshDataSource(), 200)
              )
            },
          },
          {
            text: '确定',
            onPress: () => {
              this.state.isDraft = true
              this.setState(
                { formFields: this.setFormFieldVisibleStatus(cacheFormFields) },
                () => setTimeout(this._refreshDataSource(), 200)
              )
            },
          },
        ])
      } else {
        this.setState(
          { formFields: this.setFormFieldVisibleStatus(res.data.formFields) },
          () => setTimeout(this._refreshDataSource(), 200)
        )
      }

      if (res.data.nodePermissions) {
        this.setState({ nodePermissions: JSON.parse(res.data.nodePermissions) })
      }

      setTimeout(() => {
        let mTop
        try {
          mTop = this.titleBox.offsetHeight + 10
        } catch (err) {
          mTop = 90
        }

        this.setState({ mTop: mTop })
      }, 20)

      var limitStr = ''
      if (res.data.limitStr) {
        limitStr = res.data.limitStr
      }

      var formSetting = ''
      if (res.data.formSetting) {
        formSetting = res.data.formSetting
      }

      this.setState({
        limitStr: limitStr,
        formSetting: formSetting,
        isLoading: false,
        jsapiticket: res.data.jsapiticket,
        appId: res.data.appId,
      })
      this.settingWx()
    } else {
      Toast.offline(res.msg, 2)
    }
  }

  async getDataForm() {
    const res = await _getDataForm(this.sid, this.state.formDataId)
    if (res.code === 0) {
      if (
        res.data.toaDataForm &&
        (res.data.toaDataForm.status === 1 || res.data.toaDataForm.status === 2)
      ) {
        this.props.history.push({
          pathname: 'formdetail',
          query: { formDataId: this.state.formDataId },
        })
        return
      }
      this.setState({
        toaForm: res.data.toaForm,
        lastCC: res.data.lastCC,
        fileList: res.data.fileList,
        userid: res.data.userid,
        username: res.data.username,
        formRules: res.data.formRules,
        definitionId: res.data.toaForm.definitionId,
      })

      res.data.formFields = this._initFormFields(res.data.formFields)

      res.data.formFields.map((item) => {
        if (item.fieldType === 'ChildField') {
          item.childFormFields.map((subItem) => {
            res.data.formFieldValues.map((ssItem) => {
              if (ssItem.formFieldId == subItem.fieldId && ssItem.fieldValue) {
                subItem.inputValue = JSON.parse(ssItem.fieldValue)
              }
              if (
                subItem.fieldName === '数据源' &&
                subItem.multipleValue.length === 0 &&
                subItem.inputValue.length > 0
              ) {
                subItem.multipleValue = [
                  { name: subItem.inputValue[0], isSelected: false },
                ]
              }
            })
          })
        }

        res.data.formFieldValues.map((subItem) => {
          if (subItem.formFieldId == item.fieldId && subItem.fieldValue) {
            item.inputValue = JSON.parse(subItem.fieldValue)
            if (
              item.fieldName === '数据源' &&
              item.multipleValue.length === 0 &&
              item.inputValue.length > 0
            ) {
              item.multipleValue = [
                { name: item.inputValue[0], isSelected: false },
              ]
            }
          }
        })
      })

      if (res.data.nodePermissions) {
        this.setState({ nodePermissions: JSON.parse(res.data.nodePermissions) })
      }

      setTimeout(() => {
        let mTop
        try {
          mTop = this.titleBox.offsetHeight + 10
        } catch (err) {
          mTop = 90
        }

        this.setState({ mTop: mTop })
      }, 20)
      var limitStr = ''
      if (res.data.limitStr) {
        limitStr = res.data.limitStr
      }
      this.setState(
        {
          formFields: this.setFormFieldVisibleStatus(res.data.formFields),
          transactorCC: res.data.transactorCC,
        },
        () => setTimeout(this._refreshDataSource(), 200)
      )
      this.setState({
        limitStr: limitStr,
        isLoading: false,
        jsapiticket: res.data.jsapiticket,
        appId: res.data.appId,
      })
      this.settingWx()
      if (res.data['newVersion']) {
        alert('提示', '该表单已发布新版本，请确定您填写的数据。', [
          {
            text: '确定',
            onPress: () => {},
          },
        ])
      }
    } else if (res.code === 9999) {
      cookie.remove(process.env.TOKEN_KEY, { path: '/' })
      if (this.state.code) {
        this.loginByCode()
      } else {
        this.props.history.push('/')
      }
    } else {
      Toast.offline(res.msg, 2)
    }
  }

  async loginByCode() {
    const res = await _loginByCode(this.state.code)
    if (res.code === 0) {
      const { cookies } = this.props
      cookies.set(process.env.TOKEN_KEY, res.data.sid, { path: '/' })
      this.sid = res.data.sid
      this.getDataForm()
      try {
        this.selectMemberModal.refresh(this.sid)
      } catch (error) {}
    } else {
      this.props.history.push('/')
    }
  }

  settingWx() {
    // 检查是否在微信/企业微信环境中
    const ua = navigator.userAgent.toLowerCase()
    const isWxWork = ua.includes('wxwork')
    const isWeChat = ua.includes('micromessenger')
    if (!isWxWork && !isWeChat) {
      return
    }
    var appId = this.state.appId
    var timestamp = this.state.timestamp
    var nonceStr = this.state.nonceStr
    var signature = getWxSignature(
      this.state.jsapiticket,
      nonceStr,
      timestamp,
      window.location.href
    )

    if (window.wx) {
      window.wx.config({
        beta: true,
        debug: false,
        appId: appId,
        timestamp: timestamp,
        nonceStr: nonceStr,
        signature: signature,
        jsApiList: [
          'previewImage',
          'chooseImage',
          'getLocalImgData',
          'uploadImage',
          'scanQRCode',
        ],
      })
    }
  }

  uploadImageByWx = (localId) => {
    window.wx.uploadImage({
      localId: localId,
      isShowProgressTips: 1,
      success: function (res) {
        var serverId = res.serverId
      },
    })
  }

  getLocalImgData = (data, localId, index) => {
    window.wx.getLocalImgData({
      localId: localId,
      success: function (res) {
        var localData = res.localData
      },
    })
  }

  chooseImage = (data) => {
    window.wx.chooseImage({
      count: 9,
      sizeType: ['original', 'compressed'],
      sourceType: ['album', 'camera'],
      defaultCameraMode: 'batch',
      isSaveToAlbum: 1,
      success: (res) => {
        var localIds = res.localIds
        if (localIds) {
          for (var i = 0; i < localIds.length; i++) {
            var item = localIds[i]
            window.wx.uploadImage({
              localId: item,
              isShowProgressTips: 1,
              success: (res) => {
                var serverIds = [res.serverId]
                this.uploadByWx(data, serverIds)
              },
            })
          }
        }
      },
    })
  }

  previewImage = (list, data) => {
    var urls = []
    if (list && list.length > 0) {
      list.map((item) => {
        urls.push(process.env.API_HOST + _getDownloadPath(item.url, item.name))
      })
    } else {
      urls.push(process.env.API_HOST + _getDownloadPath(data.url, data.name))
    }
    window.wx.previewImage({
      current: process.env.API_HOST + _getDownloadPath(data.url, data.name),
      urls: urls,
    })
  }

  async uploadByWx(data, serverIds) {
    const res = await _uploadByWx(this.sid, serverIds)
    if (res.code === 0) {
      if (res.data.values) {
        var fileUrlList = []
        res.data.values.map((item) => {
          item.status = 'done'
          data.inputValue.push(item)
          fileUrlList.push(item.url)
        })
        this.updateFormField(data)
        if (data.fieldType === 'OcrInvoice') {
          this.ocrVatInvoice(fileUrlList, data)
        }
      }
    }
  }

  async submitFormData(formId, status, formFields, formDataId, transactorCC) {
    this.setState({ submittingFormData: true })
    const res = await _saveForm(
      this.sid,
      formId,
      status,
      formFields,
      formDataId,
      transactorCC,
      this.state.userDepart
    )
    if (res.code === 0) {
      window.localStorage.setItem(this.state.toaForm.formId + '_formFields', '')
      this.setState({ submittingFormData: false })
      if (status == -2) {
        Toast.info('已经成功保存为草稿', 1)
        setTimeout(() => {
          this.props.history.push('/draft')
        }, 1000)
      } else {
        Toast.info('提交成功', 1)
        setTimeout(() => {
          this.props.history.push({
            pathname: '/',
            query: { selectedTab: 'mineTab' },
          })
        }, 600)
      }
    } else if (res.code === 5002) {
      this.setState({
        selectDepart: true,
        userDepartList: res.data.userDepartList,
        userDepart: res.data.userDepartList[0].id,
        actionType: res.data.actionType,
      })
    } else {
      Toast.offline(res.msg, 2)
      if (res.data && res.data.formDataId) {
        this.setState({
          submittingFormData: false,
          formDataId: res.data.formDataId,
        })
      } else {
        this.setState({ submittingFormData: false })
      }
    }
  }

  async ocrVatInvoice(fileUrlList, data) {
    if (fileUrlList) {
      var newFileUrlList = []
      for (let index = 0; index < fileUrlList.length; index++) {
        const thumbUrl = fileUrlList[index]
        var isAppend = true
        data.inputValue.map((item) => {
          if (item.invoiceInfo && item.invoiceInfo.words_result_num > 0) {
            if (item.thumbUrl === thumbUrl) {
              isAppend = false
            }
          }
        })
        if (isAppend) {
          newFileUrlList.push(thumbUrl)
        }
      }

      Toast.info('正在识别' + newFileUrlList.length + '张发票...', 300)
      const res = await _ocrVatInvoice(this.sid, newFileUrlList)
      if (res.code === 0) {
        var successNum = 0
        var tErrorNum = 0
        var newInputValue = []
        for (var i = 0; i < data.inputValue.length; i++) {
          data.inputValue[i].ocrStatus = true
          if (data.inputValue[i].url && res.data[data.inputValue[i].url]) {
            var invoiceInfo = res.data[data.inputValue[i].url]
            if (invoiceInfo.TErrorMsg) {
              if (
                this.state.removeFileList.indexOf(data.inputValue[i].url) < 0
              ) {
                this.state.removeFileList.push(data.inputValue[i].url)
                this.setState({ removeFileList: this.state.removeFileList })
              }
              tErrorNum++
              successNum++
              newInputValue.push(data.inputValue[i])
              continue
            } else {
              var isHas = false
              for (let j = 0; j < data.inputValue.length; j++) {
                const element = data.inputValue[j]
                if (element.invoiceInfo) {
                  let ekey = 'InvoiceNum'
                  const etype =
                    getFirstWord(element.invoiceInfo, 'result_type', '') ||
                    element.invoiceInfo.result_type
                  if (etype === 'vat_invoice') {
                    ekey = 'InvoiceNum'
                  } else if (etype === 'air_ticket') {
                    ekey = 'invoice_num'
                  } else if (etype === 'taxi_receipt') {
                    ekey = 'InvoiceNum'
                  } else if (etype === 'train_ticket') {
                    ekey = 'invoice_num'
                  } else if (etype === 'quota_invoice') {
                    ekey = 'invoice_number'
                  } else if (etype === 'printed_invoice') {
                    ekey = 'InvoiceNum'
                  } else if (etype === 'roll_normal_invoice') {
                    ekey = 'InvoiceNum'
                  } else if (etype === 'motor_vehicle_invoice') {
                    ekey = 'fapiao-haoma'
                  } else if (etype === 'used_vehicle_invoice') {
                    ekey = 'invoice_num'
                  }
                  const eInvoiceNum = getFirstWord(
                    element.invoiceInfo,
                    ekey,
                    ''
                  )
                  let vkey = 'InvoiceNum'
                  const vtype =
                    getFirstWord(invoiceInfo, 'result_type', '') ||
                    invoiceInfo.result_type
                  if (vtype === 'vat_invoice') {
                    vkey = 'InvoiceNum'
                  } else if (vtype === 'air_ticket') {
                    vkey = 'invoice_num'
                  } else if (vtype === 'taxi_receipt') {
                    vkey = 'InvoiceNum'
                  } else if (vtype === 'train_ticket') {
                    vkey = 'invoice_num'
                  } else if (vtype === 'quota_invoice') {
                    vkey = 'invoice_number'
                  } else if (vtype === 'printed_invoice') {
                    vkey = 'InvoiceNum'
                  } else if (vtype === 'roll_normal_invoice') {
                    vkey = 'InvoiceNum'
                  } else if (vtype === 'motor_vehicle_invoice') {
                    vkey = 'fapiao-haoma'
                  } else if (vtype === 'used_vehicle_invoice') {
                    vkey = 'invoice_num'
                  }
                  const vInvoiceNum = getFirstWord(invoiceInfo, vkey, '')
                  if (eInvoiceNum == vInvoiceNum) {
                    isHas = true
                    break
                  }
                }
              }
              if (isHas) {
                if (
                  this.state.removeFileList.indexOf(data.inputValue[i].url) < 0
                ) {
                  this.state.removeFileList.push(data.inputValue[i].url)
                  this.setState({ removeFileList: this.state.removeFileList })
                }
                tErrorNum++
                successNum++
                newInputValue.push(data.inputValue[i])
                continue
              }
              successNum++
              data.inputValue[i].invoiceInfo = invoiceInfo
            }
          }
          newInputValue.push(data.inputValue[i])
        }
        data.inputValue = JSON.parse(JSON.stringify(newInputValue))
        if (successNum > 0) {
          Toast.info('成功识别' + successNum + '张发票', 2)
        }
        if (tErrorNum > 0) {
          setTimeout(() => {
            Toast.info(tErrorNum + '张发票重复，已禁止上传', 3)
          }, 2000)
        }

        this.updateFormField(data)
      } else {
        Toast.info('识别失败，请重试', 1)
      }
    }
  }

  formDetailToggle = () => {
    this.setState({ formDetailShow: !this.state.formDetailShow })
  }

  saveFormData = (actionType) => {
    const formFields = []
    for (var i = 0; i < this.state.formFields.length; i++) {
      var item = this.state.formFields[i]
      if (item.fieldType === 'ChildField') {
        let newInputValue = []
        item.inputValue.map((subItem) => {
          if (!subItem.example) {
            newInputValue.splice(newInputValue.length, 0, subItem)
          }
        })
        item.inputValue = newInputValue
      }
      if (item.fieldType !== 'SectionBreak') {
        if (item.isVisible && item.isRequired) {
          var valueHas = true
          if (item.inputValue.length === 0 || undefined == item.inputValue[0]) {
            valueHas = false
          } else if (0 === item.inputValue[0].length) {
            valueHas = false
          } else {
            if (item.fieldType === 'TextArea' && item.inputValue.length === 2) {
              var tmp = (item.inputValue[1] + '').trim().replace(/↵/gi, '')
              if (tmp.length === 0) {
                valueHas = false
              }
            }
          }
          if (!valueHas) {
            if (actionType !== -2 && item.isReadOnly !== 'true') {
              Toast.offline('请填写' + item.fieldTitle, 1)
              var element
              if (i > 1) {
                for (var j = 1; j < i; j++) {
                  element = document.getElementById(
                    this.state.formFields[i - j].fieldId
                  )
                  if (element) {
                    break
                  }
                }
              } else {
                element = document.getElementById('formDetailBox')
              }
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' })
              }
              return
            }
          }
        }
      }

      if (item.multipleValue) {
        formFields.splice(formFields.length, 0, {
          fieldId: item.fieldId,
          fieldType: item.fieldType,
          formId: item.formId,
          inputValue: item.inputValue,
          multipleValue: item.multipleValue,
        })
      } else {
        formFields.splice(formFields.length, 0, {
          fieldId: item.fieldId,
          fieldType: item.fieldType,
          formId: item.formId,
          inputValue: item.inputValue,
        })
      }
    }

    let transactorCC = []
    if (this.state.transactorCC) {
      this.state.transactorCC.map((item, index) =>
        transactorCC.splice(index, 0, item.userid)
      )
    }
    if (
      actionType == 2 &&
      this.state.formRules &&
      this.state.formRules.length > 0
    ) {
      for (var i = 0; i < this.state.formRules.length; i++) {
        var rule = JSON.parse(JSON.stringify(this.state.formRules[i]))
        for (var j = 0; j < this.state.formFields.length; j++) {
          var field = this.state.formFields[j]
          if (rule.content.indexOf('${' + field.fieldId + '}') >= 0) {
            var value = 0
            if (field.inputValue.length > 0) {
              value = field.inputValue[0]
            }
            if (
              field.fieldType === 'RadioButton' ||
              field.fieldType === 'TextField' ||
              field.fieldType === 'DropDown' ||
              field.fieldType === 'EmailField' ||
              field.fieldType === 'MobileField'
            ) {
              rule.content = rule.content.replace(
                '${' + field.fieldId + '}',
                "'" + value + "'"
              )
            } else {
              rule.content = rule.content.replace(
                '${' + field.fieldId + '}',
                value
              )
            }
          }
        }
        try {
          if (eval(rule.content)) {
            Toast.offline(rule.tipMsg, 2)
            return
          }
        } catch (err) {
          Toast.offline('表单提交校验有误，请联系管理员', 2)
          return
        }
      }
    }
    this.submitFormData(
      this.state.toaForm.formId,
      actionType,
      formFields,
      this.state.formDataId,
      transactorCC
    )
  }

  updateFormField = (data) => {
    for (let index = 0; index < this.state.formFields.length; index++) {
      var element = this.state.formFields[index]
      if (element.fieldId === data.fieldId) {
        element = data
        break
      }
      if (
        element.fieldType === 'ChildField' ||
        element.fieldType === 'FORMREFCustomerField'
      ) {
        var isHas = false
        for (
          let subIndex = 0;
          subIndex < element.childFormFields.length;
          subIndex++
        ) {
          var subElement = element.childFormFields[subIndex]
          if (subElement.fieldId === data.fieldId) {
            subElement = data
            isHas = true
            break
          }
        }
        if (isHas) {
          element.childFormFields = this.setFormFieldVisibleStatus(
            element.childFormFields
          )
          break
        }
      }
    }

    this.state.formFields.map((item) => {
      if (item.fieldType === 'EquationField') {
        item.inputValue = [_getEquationFieldValue(item, this.state.formFields)]
        if (this.mainFormRef.current) {
          this.mainFormRef.current.setFieldsValue({
            [item.fieldId]: item.inputValue[0],
          })
        }
      } else if (
        item.fieldType === 'ChildField' ||
        item.fieldType === 'FORMREFCustomerField'
      ) {
        item.childFormFields.map((subItem) => {
          if (subItem.fieldType === 'EquationField') {
            subItem.inputValue = [
              _getEquationFieldValue(subItem, this.state.formFields),
            ]
            var formItemName = subItem.fieldId
            if (this.state.childFormDrawerOpen) {
              formItemName +=
                '_' + this.randomFlag + '_' + this.state.currentRow
            }
            this.childFormRef.current.setFieldsValue({
              [formItemName]: subItem.inputValue[0],
            })
          } else if (subItem.fieldType === 'ChildField') {
            subItem.childFormFields.map((sonItem) => {
              if (sonItem.fieldType === 'EquationField') {
                sonItem.inputValue = [
                  _getEquationFieldValue(sonItem, this.state.formFields),
                ]
                var formItemName = sonItem.fieldId
                if (this.state.childFormDrawerOpen) {
                  formItemName +=
                    '_' + this.randomFlag + '_' + this.state.currentRow
                }
                this.childFormRef.current.setFieldsValue({
                  [formItemName]: sonItem.inputValue[0],
                })
              }
            })
            subItem.childFormFields = this.setFormFieldVisibleStatus(
              subItem.childFormFields
            )
          }
        })
        item.childFormFields = this.setFormFieldVisibleStatus(
          item.childFormFields
        )
      }
    })

    this.state.formFields.map((item) => {
      if (
        item.defaultValueType == 4 &&
        item.defaultValue &&
        item.fieldId !== data.fieldId
      ) {
        item = _updateFormFieldDefaultValue(item, this.state.formFields)
        if (this.mainFormRef.current) {
          this.mainFormRef.current.setFieldsValue({
            [item.fieldId]: item.inputValue[0],
          })
        }
      }
      if (
        item.fieldType === 'ChildField' ||
        item.fieldType === 'FORMREFCustomerField'
      ) {
        item.childFormFields.map((subItem) => {
          if (subItem.fieldType === 'ChildField') {
            subItem.childFormFields.map((sonItem) => {
              if (
                sonItem.defaultValueType == 4 &&
                sonItem.defaultValue &&
                sonItem.fieldId !== data.fieldId
              ) {
                sonItem = _updateFormFieldDefaultValue(
                  sonItem,
                  this.state.formFields
                )
                var formItemName = sonItem.fieldId
                if (this.state.childFormDrawerOpen) {
                  formItemName +=
                    '_' + this.randomFlag + '_' + this.state.currentRow
                }
                this.childFormRef.current.setFieldsValue({
                  [formItemName]: sonItem.inputValue[0],
                })
              }
            })
          } else {
            if (
              subItem.defaultValueType == 4 &&
              subItem.defaultValue &&
              subItem.fieldId !== data.fieldId
            ) {
              subItem = _updateFormFieldDefaultValue(
                subItem,
                this.state.formFields
              )
              var formItemName = subItem.fieldId
              if (this.state.childFormDrawerOpen) {
                formItemName +=
                  '_' + this.randomFlag + '_' + this.state.currentRow
              }
              this.childFormRef.current.setFieldsValue({
                [formItemName]: subItem.inputValue[0],
              })
            }
          }
        })
        item.childFormFields = this.setFormFieldVisibleStatus(
          item.childFormFields
        )
      }
    })

    this.state.formFields = this.setFormFieldVisibleStatus(
      this.state.formFields
    )
    this.setState({ formFields: this.state.formFields })
    if (!this.state.formDataId) {
      window.localStorage.setItem(
        this.state.toaForm.formId + '_formFields',
        JSON.stringify(this.state.formFields)
      )
    }
  }

  setFormFieldVisibleStatus = (formFieldList) => {
    var nodePermissions = this.state.nodePermissions
    if (!nodePermissions) {
      nodePermissions = {}
    }

    return _setFormFieldVisibleStatus(
      formFieldList,
      nodePermissions,
      1,
      undefined,
      undefined
    )
  }

  onNumberChange = (value, data) => {
    // if (!value || typeof (value) !== 'number') {
    //     value = '';
    // }
    data = _onNumberChange(value, data)
    this.updateFormField(data)
  }

  onCommonChange = (e, data) => {
    data.inputValue = [e.target.value]
    this.updateFormField(data)
  }

  onPickerChange = (e, data) => {
    data.inputValue = e
    this.updateFormField(data)
  }

  onCheckBoxChange = (checkedList, data) => {
    if (data.maxLength > 0 && checkedList.length > data.maxLength) {
      Toast.info('最多选' + data.maxLength + '个', 1)
      return
    }
    data.inputValue = checkedList
    this.updateFormField(data)
  }

  onTextAreaChange = (value, data) => {
    if (value) {
      var reg =
        /<!--\[if\s+gte\s+mso\s+\d+\]>(?:(?!<!\[endif\]-->)[\s\S])*<!\[endif\]-->/
      value = value.replace(reg, '')
    }
    data.inputValue = [value, value]
    this.updateFormField(data)
  }

  onUploadChange = (info, data) => {
    if (info.file.response && info.file.response.code === 0) {
      info.file.url = info.file.response.data.fileUrl
      var fileList = []
      info.fileList.map((item) => {
        if (!item.url && item.response && item.response.data) {
          item.url = item.response.data.fileUrl
        }
        if (item.type.indexOf('image/') === 0) {
          item.thumbUrl = item.url
        }
        if (item.url) {
          fileList.push(item)
        }
      })
      data.inputValue = fileList
      this.updateFormField(data)
    }
  }

  mergeFileList = (list) => {
    const removedUrls = this.state.removeFileList || []
    const map = new Map()

    list.forEach((file) => {
      const key = file.uid || file.url

      if (file.url && removedUrls.includes(file.url)) {
        return
      }

      if (!map.has(key)) {
        map.set(key, file)
        return
      }

      const old = map.get(key)

      // done 覆盖 uploading
      if (old.status !== 'done' && file.status === 'done') {
        map.set(key, file)
      }
    })

    return Array.from(map.values())
  }

  onOcrVatInvoiceChange = async (info, data) => {
    if (!info) return

    let fileList = info.fileList.map((f) => {
      // 上传完成时修正 url
      if (f.status === 'done' && !f.url) {
        if (f.response && f.response.data) {
          f.url = f.response.data.fileUrl
        }
      }
      return f
    })

    // ========== 在判断是否全部上传完成之前排除 removeFileList ==========
    const removedUrls = this.state.removeFileList || []
    fileList = fileList.filter((f) => !removedUrls.includes(f.url))

    // ----------- 判断是否全部上传完成 -------------------
    const allDone = fileList.every((f) => f.status === 'done')

    // 更新 inputValue
    data.inputValue = this.mergeFileList([...data.inputValue, ...info.fileList])
    this.updateFormField(data)

    // ---------- 如果没全部完成，不识别 ----------
    if (!allDone) return

    // ---------- 全部完成，再统一识别 ----------
    const newFileUrls = fileList.map((f) => f.url)
    let newFiles = newFileUrls.filter((f) => {
      return this.state.lastRecognizedList.indexOf(f) < 0
    })

    if (newFiles.length > 0) {
      await this.ocrVatInvoice(newFiles, data)
      // 更新 lastRecognizedList
      this.setState({
        lastRecognizedList: [
          ...new Set(this.state.lastRecognizedList.concat(newFiles)),
        ],
      })
    }

    if (data.inputValue) {
      for (let index = data.inputValue.length - 1; index >= 0; index--) {
        const element = data.inputValue[index]
        if (element.status === 'done') {
          var isHas = false
          for (let i = 0; i < fileList.length; i++) {
            const ele = fileList[i]
            if (ele.url && ele.url === element.url) {
              isHas = true
              break
            }
          }
          if (!isHas) {
            fileList.unshift(element)
          }
        }
      }
    }

    data.inputValue = this.mergeFileList([...data.inputValue, ...info.fileList])
    this.updateFormField(data)
  }

  randomFlag = ''
  onDrawerOpenChange = () => {
    this.randomFlag = _randomString(6)
    if (this.state.preFormField) {
      var tmpFormField = this.state.preFormField
      var tmpRowIndex = this.state.preRowIndex
      this.setState({
        preFormField: '',
        preRowIndex: -1,
        currentFormField: tmpFormField,
        currentRow: tmpRowIndex,
      })
      return
    }
    this.setState({ childFormDrawerOpen: !this.state.childFormDrawerOpen })
  }

  addImageOnClick(data) {
    this.chooseImage(data)
  }

  scanQRCode(data) {
    window.wx.scanQRCode({
      desc: 'scanQRCode desc',
      needResult: 0,
      scanType: ['qrCode', 'barCode'],
      success: function (res) {},
      error: function (res) {
        if (res.errMsg.indexOf('function_not_exist') > 0) {
          alert('版本过低请升级')
        }
      },
    })
  }

  resetChildFormFields = (data) => {
    data.childFormFields.map((item) => {
      item.inputValue = []
      if (item.selectedValue) {
        item.inputValue = [item.selectedValue]
      }
      if (item.multipleValue) {
        item.multipleValue.map((subItem) => {
          if (subItem.isSelected) {
            item.inputValue.splice(item.inputValue.length, 0, subItem.name)
          }
        })
      }
    })
    data.childFormFields = this.setFormFieldVisibleStatus(data.childFormFields)

    return data
  }

  addChildForm = (obj) => {
    this.setState(
      { currentFormField: this.resetChildFormFields(obj), currentRow: -1 },
      () => {
        this.onDrawerOpenChange()
      }
    )
  }

  updateStatisticsValue = (data) => {
    this.state.formFields.map((item) => {
      if (item.fieldType === 'StatisticsField') {
        var moreSetting = item.moreSetting
        if (
          moreSetting &&
          moreSetting.statistics &&
          moreSetting.statistics.values &&
          moreSetting.statistics.values.length >= 2
        ) {
          if (data.fieldId == moreSetting.statistics.values[0]) {
            item.inputValue = [_getStatisticsValue(item, data)]
            this.updateFormField(item)
          }
        }
      } else if (item.fieldType === 'FORMREFCustomerField') {
        item.childFormFields.map((subItem) => {
          if (subItem.fieldType === 'StatisticsField') {
            var moreSetting = subItem.moreSetting
            if (
              moreSetting &&
              moreSetting.statistics &&
              moreSetting.statistics.values &&
              moreSetting.statistics.values.length >= 2
            ) {
              if (data.fieldId == moreSetting.statistics.values[0]) {
                subItem.inputValue = [_getStatisticsValue(subItem, data)]
                this.updateFormField(subItem)
              }
            }
          }
        })
      }
    })
  }

  saveChildForm = () => {
    let dataObj = this.state.currentFormField.inputValue[this.state.currentRow]
    if (undefined == dataObj) {
      dataObj = {}
    }
    dataObj = _checkChildFormInputValue(
      dataObj,
      this.state.currentFormField.childFormFields
    )
    if (!dataObj) {
      return false
    }
    let formFieldValue = this.state.currentFormField.inputValue
    if (this.state.currentRow === -1) {
      dataObj.key = formFieldValue.length + 1
    }

    if (this.state.currentFormField.fieldType === 'FORMREFCustomerField') {
      this.state.currentFormField.preInputValue = JSON.parse(
        JSON.stringify(this.state.currentFormField.inputValue)
      )
    }
    dataObj.example = false
    this.state.currentRow === -1
      ? this.state.currentFormField.inputValue.splice(
          formFieldValue.length,
          0,
          dataObj
        )
      : this.state.currentFormField.inputValue.splice(
          this.state.currentRow,
          1,
          dataObj
        )
    this.updateStatisticsValue(this.state.currentFormField)
    this.state.formFields.map((item) =>
      item.fieldType === 'FORMREFCustomerField'
        ? item.childFormFields.map((subItem) =>
            subItem.fieldId === this.state.currentFormField.fieldId
              ? (subItem = this.state.currentFormField)
              : ''
          )
        : ''
    )
    this.updateFormField(this.state.currentFormField)

    return true
  }

  saveChildFormBack = () => {
    if (this.saveChildForm()) {
      if (
        this.state.currentFormField &&
        this.state.currentFormField.fieldType === 'FORMREFCustomerField'
      ) {
        this.state.currentFormField.childFormFields.map((item) => {
          if (item.fieldType === 'ChildField') {
            item.childFormFields.map((subItem) => {
              subItem.editing = -1
            })
          }
        })
        this.setState({ currentFormField: this.state.currentFormField })
      }
      this.onDrawerOpenChange()
    }
  }

  saveChildFormGoOn = () => {
    if (this.saveChildForm()) {
      Toast.info('已保存', 1)
      this.randomFlag = _randomString(6)
      this.state.currentFormField.childFormFields.map((item) => {
        if (
          item.fieldType !== 'CascadeDropDown' &&
          item.fieldType !== 'CUSTOMIZE_RadioButton' &&
          item.fieldType !== 'TextField'
        ) {
          item.inputValue = []
          if (item.selectedValue) {
            item.inputValue = [item.selectedValue]
          }
          if (item.multipleValue) {
            item.multipleValue.map((subItem) => {
              if (subItem.isSelected) {
                item.inputValue.splice(item.inputValue.length, 0, subItem.name)
              }
            })
          }
        }
      })
      this.setState({
        currentFormField: this.state.currentFormField,
        currentRow: -1,
      })
    }
  }

  renderChildFormDetail = () => {
    return (
      <div
        className={styles.childFormContainer}
        style={{
          width: document.documentElement.clientWidth,
          maxWidth: this.state.fullScreenChild ? 'unset' : 600,
        }}
      >
        <Form
          className={styles.formContent}
          validateMessages={validateMessages}
          ref={this.childFormRef}
        >
          {this.state.currentFormField.childFormFields.map((item) =>
            item.isVisible ? (
              <div className={styles.formGroup} key={item.fieldId}>
                <div
                  className={styles.formLabel}
                  style={{ padding: '10px 0 10px' }}
                >
                  {item.fieldType !== 'SectionBreak' ? (
                    <label className={styles.controlLabel}>
                      {item.fieldTitle}
                      {item.isRequired ? (
                        <span className={styles.colorRed}> *</span>
                      ) : (
                        ''
                      )}
                    </label>
                  ) : (
                    ''
                  )}
                  {item.tip ? (
                    <div className={styles.fieldNotes}>
                      <p
                        dangerouslySetInnerHTML={{ __html: item.tipMedium }}
                      ></p>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
                <div className={styles.fieldContent} id={item.fieldId}>
                  <div
                    className={
                      this.state.fullScreenChild == item.fieldId
                        ? `${styles.childFormFullScreen}`
                        : ``
                    }
                  >
                    {this.renderFormField(item)}
                  </div>
                </div>
                <div className={styles.helpBlock}></div>
              </div>
            ) : (
              ''
            )
          )}
        </Form>
        <div className={styles.childFormFootctrl}>
          {this.state.currentFormField &&
          this.state.currentFormField.fieldType === 'FORMREFCustomerField' ? (
            <div style={{ display: 'flex', width: '100%' }}>
              <Button
                style={{ flex: 0.5, height: 44, marginRight: 15 }}
                onClick={() => {
                  if (this.state.currentFormField.preInputValue) {
                    this.state.currentFormField.inputValue = JSON.parse(
                      JSON.stringify(this.state.currentFormField.preInputValue)
                    )
                    this.updateFormField(this.state.currentFormField)
                  }

                  this.setState({ currentFormField: { childFormFields: [] } })
                  this.onDrawerOpenChange()
                }}
              >
                返回
              </Button>
              <Button
                style={{ flex: 0.5, height: 44, marginRight: 15 }}
                onClick={this.saveChildFormBack}
              >
                保存
              </Button>
            </div>
          ) : (
            <div style={{ display: 'flex', width: '100%' }}>
              <Button
                style={{ flex: 0.5, height: 44, marginRight: 15 }}
                onClick={() => {
                  this.setState({ currentFormField: { childFormFields: [] } })
                  this.onDrawerOpenChange()
                }}
              >
                取消
              </Button>
              <Button
                style={{ flex: 1, height: 44, marginRight: 15 }}
                onClick={this.saveChildFormBack}
              >
                保存
              </Button>
              <Button
                style={{ flex: 1, height: 44 }}
                type="primary"
                onClick={this.saveChildFormGoOn}
              >
                保存并新增
              </Button>
            </div>
          )}
        </div>
      </div>
    )
  }

  renderFormField = (data) => {
    var initialValue =
      data.inputValue.length > 0 ? (initialValue = data.inputValue[0]) : ''
    var formItemName = data.fieldId
    if (this.state.childFormDrawerOpen) {
      formItemName += '_' + this.randomFlag + '_' + this.state.currentRow
    }

    const inputNumberView = (
      <span>
        <input
          onBlur={() => window.scrollTo(0, 0)}
          type="text"
          readOnly={data.isReadOnly}
          maxLength="2000"
          className={[
            `${styles.textField}`,
            data.isReadOnly ? `${styles.readOnly}` : ``,
          ].join(' ')}
          value={data.inputValue[0]}
          onChange={(e) => this.onCommonChange(e, data)}
        />
        {data.isCapital ? (
          <div className={styles.inputExtra}>
            大写金额（人民币）：{convertCurrency(data.inputValue[0])}
          </div>
        ) : (
          ''
        )}
      </span>
    )

    switch (data.fieldType) {
      case 'MobileField':
        return (
          <Form.Item
            name={[formItemName]}
            initialValue={initialValue}
            rules={[
              {
                pattern: new RegExp(
                  '^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}',
                  'g'
                ),
                message: '输入的格式不正确',
              },
            ]}
          >
            <Input
              maxLength={11}
              readOnly={data.isReadOnly}
              className={[
                `${styles.textField}`,
                data.isReadOnly ? `${styles.readOnly}` : ``,
              ].join(' ')}
              onBlur={(e) => {
                window.scrollTo(0, 0)
                this.onCommonChange(e, data)
              }}
            />
          </Form.Item>
        )
      case 'NumberField':
        var precision = ''
        if (
          data.moreSetting &&
          undefined != data.moreSetting.decimalPoint &&
          data.moreSetting.decimalPoint != -1
        ) {
          if (initialValue && initialValue != 0) {
            precision = data.moreSetting.decimalPoint
          }
        }

        // Mac企业微信和iOS使用原生input，避免InputNumber自动加小数点问题和小数精度问题
        if (isMacQiyeweixin() || isIOS()) {
          const decimalPoint = precision
          return (
            <Form.Item
              name={[formItemName]}
              initialValue={initialValue}
              extra={
                data.isCapital ? (
                  <div>大写金额（人民币）：{convertCurrency(initialValue)}</div>
                ) : (
                  ''
                )
              }
            >
              <Input
                type="text"
                inputMode="decimal"
                readOnly={data.isReadOnly}
                className={[
                  `${styles.textField}`,
                  data.isReadOnly ? `${styles.readOnly}` : ``,
                ].join(' ')}
                onChange={(e) => {
                  const value = e.target.value
                  // 只允许输入数字和小数点，并根据precision限制小数位数
                  if (value === '' || /^-?\d*\.?\d*$/.test(value)) {
                    // 如果有设置小数位数，则限制输入
                    if (
                      decimalPoint !== undefined &&
                      decimalPoint !== -1 &&
                      value.indexOf('.') !== -1
                    ) {
                      const parts = value.split('.')
                      if (parts[1] && parts[1].length > decimalPoint) {
                        // 超过小数位数限制，不更新
                        return
                      }
                    }
                    this.onNumberChange(
                      value === '' ? null : Number(value),
                      data
                    )
                  }
                }}
                onBlur={(e) => {
                  window.scrollTo(0, 0)
                  // 失去焦点时，根据precision格式化数值
                  const value = e.target.value
                  if (
                    value !== '' &&
                    decimalPoint !== undefined &&
                    decimalPoint !== -1 &&
                    decimalPoint > 0
                  ) {
                    const numValue = Number(value)
                    if (!isNaN(numValue)) {
                      const formatted = numValue.toFixed(decimalPoint) // 字符串 "1.00"
                      this.onNumberChange(Number(formatted), data) // 存储数值
                      // 使用 setFieldsValue 更新表单显示值（使用字符串以保留小数位）
                      if (
                        this.state.childFormDrawerOpen &&
                        this.childFormRef.current
                      ) {
                        this.childFormRef.current.setFieldsValue({
                          [formItemName]: formatted,
                        })
                      } else if (this.mainFormRef.current) {
                        this.mainFormRef.current.setFieldsValue({
                          [formItemName]: formatted,
                        })
                      }
                    }
                  }
                }}
              />
            </Form.Item>
          )
        }

        if (precision != '') {
          return (
            <Form.Item
              name={[formItemName]}
              initialValue={initialValue}
              rules={[{ type: 'number' }]}
              extra={
                data.isCapital ? (
                  <div>大写金额（人民币）：{convertCurrency(initialValue)}</div>
                ) : (
                  ''
                )
              }
            >
              <InputNumber
                onBlur={() => window.scrollTo(0, 0)}
                precision={precision}
                readOnly={data.isReadOnly}
                className={[
                  `${styles.textField}`,
                  data.isReadOnly ? `${styles.readOnly}` : ``,
                ].join(' ')}
                style={{ overflowX: 'hidden' }}
                onChange={(value) => this.onNumberChange(value, data)}
                onStep={(e) => {
                  const v = e.target.value
                  if (v !== undefined && v !== '') {
                    const fixed = Number(v).toFixed(precision)
                    this.onNumberChange(Number(fixed), data)
                  }
                }}
                parser={(value) => {
                  if (value) {
                    if (value.indexOf('.') == -1) {
                      return value
                    } else {
                      var parts = value.split('.')
                      var IntegerNum = parts[0]
                      if (data.moreSetting.decimalPoint === 0) {
                        return IntegerNum
                      } else {
                        var DecimalNum = parts[1].substr(
                          0,
                          data.moreSetting.decimalPoint
                        )
                        return IntegerNum + '.' + DecimalNum
                      }
                    }
                  }
                }}
              />
            </Form.Item>
          )
        } else {
          return (
            <Form.Item
              name={[formItemName]}
              initialValue={initialValue}
              rules={[{ type: 'number' }]}
              extra={
                data.isCapital ? (
                  <div>大写金额（人民币）：{convertCurrency(initialValue)}</div>
                ) : (
                  ''
                )
              }
            >
              <InputNumber
                readOnly={data.isReadOnly}
                style={{ overflowX: 'hidden' }}
                className={[
                  `${styles.textField}`,
                  data.isReadOnly ? `${styles.readOnly}` : ``,
                ].join(' ')}
                onChange={(value) => this.onNumberChange(value, data)}
              />
            </Form.Item>
          )
        }
      case 'EmailField':
        return (
          <Form.Item
            name={[formItemName]}
            initialValue={initialValue}
            rules={[{ type: 'email' }]}
          >
            <Input
              readOnly={data.isReadOnly}
              className={[
                `${styles.textField}`,
                data.isReadOnly ? `${styles.readOnly}` : ``,
              ].join(' ')}
              onBlur={(e) => {
                window.scrollTo(0, 0)
                this.onCommonChange(e, data)
              }}
            />
          </Form.Item>
        )
      case 'TextField':
        return (
          <input
            onBlur={() => window.scrollTo(0, 0)}
            type="text"
            readOnly={data.isReadOnly}
            maxLength="2000"
            className={[
              `${styles.textField}`,
              data.isReadOnly ? `${styles.readOnly}` : ``,
            ].join(' ')}
            value={initialValue}
            onChange={(e) => this.onCommonChange(e, data)}
          />
        )
      case 'TextArea':
        return (
          <div className={styles.textareaField} initialValue={initialValue}>
            {data.isReadOnly ? (
              <TextareaItem
                editable={!data.isReadOnly}
                rows={5}
                defaultValue={initialValue}
                className="readonly_textarea"
              ></TextareaItem>
            ) : (
              <TextareaItem
                onBlur={() => window.scrollTo(0, 0)}
                editable={!data.isReadOnly}
                rows={4}
                value={initialValue}
                onChange={(value) => this.onTextAreaChange(value, data)}
              ></TextareaItem>
            )}
          </div>
        )
      case 'RadioButton':
        if (
          data.moreSetting &&
          data.moreSetting.dataSourceUrl &&
          data.moreSetting.isFullScreen
        ) {
          var reqParams = []
          for (var i = 0; i < this.state.formFields.length; i++) {
            var item = this.state.formFields[i]
            if (
              data.moreSetting.dataSourceUrl.indexOf(
                '${' + item.fieldId + '}'
              ) > 0
            ) {
              reqParams.push(item)
            }
          }
          var valueStr = ''
          if (data.inputValue) {
            for (var i = 0; i < data.inputValue.length; i++) {
              valueStr += data.inputValue[i]
              if (i < data.inputValue.length - 1) {
                valueStr += ', '
              }
            }
          }
          return (
            <div
              onBlur={() => window.scrollTo(0, 0)}
              onClick={() => {
                this.setState(
                  {
                    selectedData: data.inputValue,
                    selectedExtra: {
                      type: 200,
                      data,
                      maxLength: data.maxLength,
                      formId: this.state.toaForm.formId,
                      fieldId: data.fieldId,
                      reqParams: reqParams,
                    },
                  },
                  () => setTimeout(this.selectSourceDataModal.showModal(), 20)
                )
              }}
              className={[`${styles.textField}`, `${styles.readOnly}`].join(
                ' '
              )}
              style={{
                height: 'auto',
                minHeight: '40px',
                wordBreak: 'break-all',
                overflow: 'hidden',
              }}
            >
              {valueStr}
            </div>
          )
        }
        return (
          <Radio.Group
            value={data.inputValue[0]}
            className={[
              `${styles.choiceField}`,
              data.isReadOnly ? `${styles.readOnly}` : ``,
            ].join(' ')}
            onChange={(e) => this.onCommonChange(e, data)}
          >
            {data.multipleValue.map((item, index) => (
              <div
                key={index}
                className={styles.choiceFieldItem}
                style={{ width: 100 / data.showType + '%' }}
              >
                <Radio
                  disabled={data.isReadOnly}
                  value={item.name}
                  style={{
                    display: 'block',
                    width: '100%',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                  }}
                >
                  {item.name}
                </Radio>
              </div>
            ))}
          </Radio.Group>
        )
      case 'DropDown':
        const dropDownData = []
        data.multipleValue.map((item, index) => {
          dropDownData.splice(index, 0, { label: item.name, value: item.name })
        })
        return (
          <Picker
            data={dropDownData}
            extra={data.tip}
            cols={1}
            onChange={(e) => this.onPickerChange(e, data)}
            value={data.inputValue}
          >
            <List.Item
              arrow="horizontal"
              style={{ border: '1px solid #e5e5e5', borderRadius: 4 }}
            >
              {data.fieldTitle}
            </List.Item>
          </Picker>
        )
      case 'CheckBox':
        const checkboxData = []
        data.multipleValue.map((item, index) => {
          checkboxData.splice(index, 0, item.name)
        })
        return (
          <CheckboxGroup
            value={data.inputValue}
            onChange={(e) => this.onCheckBoxChange(e, data)}
            className={[
              `${styles.choiceField}`,
              data.isReadOnly ? `${styles.readOnly}` : ``,
            ].join(' ')}
          >
            {checkboxData.map((item, index) => (
              <div
                key={index}
                className={styles.choiceFieldItem}
                style={{ width: 100 / data.showType + '%' }}
              >
                <Checkbox
                  disabled={data.isReadOnly}
                  key={item}
                  value={item}
                  style={{
                    display: 'block',
                    width: '100%',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                  }}
                >
                  {item}
                </Checkbox>
              </div>
            ))}
          </CheckboxGroup>
        )
      case 'SectionBreak':
        return (
          <div>
            <div className={styles.sectionField}></div>
            <div className={styles.sectionFieldLabel}>{data.fieldTitle}</div>
          </div>
        )
      case 'DateField':
        var valueStr = ''
        if (data.isReadOnly) {
          valueStr = moment(new Date().getTime()).format('YYYY-MM-DD')
          return (
            <input
              type="text"
              readOnly
              className={[`${styles.textField}`, `${styles.readOnly}`].join(
                ' '
              )}
              value={valueStr}
            />
          )
        } else {
          var value = new Date()
          if (data.inputValue[0]) {
            value = new Date(data.inputValue[0])
            valueStr = moment(data.inputValue[0]).format('YYYY-MM-DD')
          }
          return (
            <span>
              {isQiyeweixinApp() ? (
                <DatePicker
                  format
                  mode="date"
                  value={value}
                  onChange={(date) => {
                    data.inputValue = [date.getTime()]
                    this.updateFormField(data)
                  }}
                >
                  <Input
                    type="text"
                    readOnly
                    className={styles.textField}
                    value={valueStr}
                    style={{ overflowX: 'unset' }}
                    allowClear
                    onChange={() => {
                      data.inputValue = []
                      this.updateFormField(data)
                    }}
                  />
                </DatePicker>
              ) : (
                <Space direction="vertical" style={{ width: '100%' }}>
                  <PcDatePicker
                    style={{ overflowX: 'hidden' }}
                    format="YYYY-MM-DD"
                    className={styles.textField}
                    defaultValue={
                      data.inputValue[0] ? moment(data.inputValue[0]) : ''
                    }
                    onChange={(date, dateString) => {
                      data.inputValue = [moment(date).valueOf()]
                      this.updateFormField(data)
                    }}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  />
                </Space>
              )}
            </span>
          )
        }
      case 'TimeField':
        var valueStr = ''
        if (data.isReadOnly) {
          valueStr = moment(new Date().getTime()).format('HH:mm')
          return (
            <input
              type="text"
              readOnly
              className={[`${styles.textField}`, `${styles.readOnly}`].join(
                ' '
              )}
              value={valueStr}
            />
          )
        } else {
          var value = new Date()
          if (data.inputValue[0]) {
            value = new Date(data.inputValue[0])
            valueStr = moment(data.inputValue[0]).format('HH:mm')
          }
          return (
            <span>
              {isQiyeweixinApp() ? (
                <DatePicker
                  format
                  mode="time"
                  value={value}
                  onChange={(date) => {
                    data.inputValue = [date.getTime()]
                    this.updateFormField(data)
                  }}
                >
                  <Input
                    type="text"
                    readOnly
                    className={styles.textField}
                    value={valueStr}
                    style={{ overflowX: 'unset' }}
                    allowClear
                    onChange={() => {
                      data.inputValue = []
                      this.updateFormField(data)
                    }}
                  />
                </DatePicker>
              ) : (
                <TimePicker
                  style={{ overflowX: 'hidden' }}
                  className={styles.textField}
                  defaultValue={valueStr ? moment(valueStr, 'HH:mm') : ''}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  onChange={(date, timeString) => {
                    data.inputValue = [moment(date).valueOf()]
                    this.updateFormField(data)
                  }}
                  format="HH:mm"
                />
              )}
            </span>
          )
        }
      case 'DateTimeField':
        var valueStr = ''
        if (data.isReadOnly) {
          valueStr = moment(new Date().getTime()).format('YYYY-MM-DD HH:mm')
          return (
            <input
              type="text"
              readOnly
              className={[`${styles.textField}`, `${styles.readOnly}`].join(
                ' '
              )}
              value={valueStr}
            />
          )
        } else {
          var value = new Date()
          if (data.inputValue[0]) {
            value = new Date(data.inputValue[0])
            valueStr = moment(data.inputValue[0]).format('YYYY-MM-DD HH:mm')
          }
          return (
            <span>
              {isQiyeweixinApp() ? (
                <DatePicker
                  format
                  mode="datetime"
                  value={value}
                  onChange={(date) => {
                    data.inputValue = [date.getTime()]
                    this.updateFormField(data)
                  }}
                >
                  <Input
                    type="text"
                    readOnly
                    className={styles.textField}
                    value={valueStr}
                    style={{ overflowX: 'unset' }}
                    allowClear
                    onChange={() => {
                      data.inputValue = []
                      this.updateFormField(data)
                    }}
                  />
                </DatePicker>
              ) : (
                <Space direction="vertical" style={{ width: '100%' }}>
                  <PcDatePicker
                    showTime
                    style={{ overflowX: 'hidden' }}
                    format="YYYY-MM-DD HH:mm"
                    className={styles.textField}
                    defaultValue={
                      data.inputValue[0] ? moment(data.inputValue[0]) : null
                    }
                    onChange={(date, dateString) => {
                      data.inputValue = [moment(date).valueOf()]
                      this.updateFormField(data)
                    }}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  />
                </Space>
              )}
            </span>
          )
        }
      case 'StaffField':
        return (
          <div>
            {data.inputValue.length > 0 ? (
              <div className={styles.relativeField}>
                {data.inputValue.map((item, index) => (
                  <div key={index} className={styles.relativeList}>
                    <span className={styles.relativeListItemIcon}></span>
                    {item.name}
                  </div>
                ))}
              </div>
            ) : (
              ''
            )}
            {data.isReadOnly ? (
              <div></div>
            ) : (
              <div
                className={styles.childFormItemAdd}
                onClick={(e) => {
                  if (data.isReadOnly) {
                    Toast.info('只读字段', 1)
                    return
                  }
                  e.preventDefault()
                  this.setState(
                    {
                      selectedData: data.inputValue,
                      selectedExtra: {
                        type: 2,
                        data,
                        maxLength: data.maxLength,
                      },
                    },
                    () => setTimeout(this.selectMemberModal.showModal(), 20)
                  )
                }}
              >
                点击添加
              </div>
            )}
          </div>
        )
      case 'ChildField':
        var myDataSource = []
        if (data.inputValue.length === 0) {
          data.inputValue = [{ id: 1, key: 1, example: true }]
        }

        myDataSource = JSON.parse(JSON.stringify(data.inputValue))
        for (var i = 0; i < myDataSource.length; i++) {
          for (var val in myDataSource[i]) {
            if (
              myDataSource[i][val] instanceof Array &&
              myDataSource[i][val].length > 0
            ) {
              for (var j = 0; j < myDataSource[i][val].length; j++) {
                if (
                  myDataSource[i][val][j] &&
                  !(myDataSource[i][val][j] instanceof String) &&
                  myDataSource[i][val][j].name
                ) {
                  myDataSource[i][val][j] = myDataSource[i][val][j].name + ', '
                }
              }
            }
          }
        }

        let columns = [
          {
            title: (
              <span
                onClick={() => {
                  var element = $('.am-drawer-sidebar')
                  if (this.state.fullScreenChild == data.fieldId) {
                    this.setState({ fullScreenChild: '' })
                    element.css('left', '')
                    element.css('top', '')
                    element.css('position', '')
                  } else {
                    element.css('left', 0)
                    element.css('top', 0)
                    element.css('position', 'fixed')
                    this.setState({ fullScreenChild: data.fieldId })
                  }
                }}
                className={
                  this.state.fullScreenChild == data.fieldId
                    ? [
                        `${styles.icon_btn}`,
                        `${styles.ic_child_fullScreen}`,
                      ].join(' ')
                    : [`${styles.icon_btn}`, `${styles.ic_child_normal}`].join(
                        ' '
                      )
                }
              ></span>
            ),
            width: 60,
            dataIndex: 'id',
            key: 'id',
            fixed: 'left',
            align: 'center',
            render: (text, record, index) => (
              <span className={styles.childControlBtn}>
                {!this.state.currentFormField ||
                (this.state.currentFormField &&
                  this.state.currentFormField.fieldType !==
                    'FORMREFCustomerField') ? (
                  <span>
                    <span
                      onClick={() => {
                        let newRecord = JSON.parse(
                          JSON.stringify(data.inputValue[index])
                        )
                        newRecord.key = data.inputValue.length + 1
                        newRecord.id = newRecord.key
                        data.inputValue.splice(index + 1, 0, newRecord)
                        this.updateStatisticsValue(data)
                        this.updateFormField(data)
                      }}
                      className={[
                        `${styles.icon_btn}`,
                        `${styles.ic_child_copy}`,
                      ].join(' ')}
                    ></span>
                    {index != 0 ? (
                      <span
                        onClick={() => {
                          data.inputValue.splice(index, 1)
                          this.updateStatisticsValue(data)
                          this.updateFormField(data)
                        }}
                        className={[
                          `${styles.icon_btn}`,
                          `${styles.ic_child_del}`,
                        ].join(' ')}
                      ></span>
                    ) : (
                      ''
                    )}
                  </span>
                ) : (
                  <span>{index + 1}</span>
                )}
              </span>
            ),
          },
        ]

        var width = 200
        if (data.childFormFields.length <= 2) {
          width = (100 % data.childFormFields.length) + '%'
        }
        if (this.state.fullScreenChild == data.fieldId) {
          width = 'auto'
        }

        data.childFormFields.map((item, i) => {
          let column = {
            title: (
              <span>
                {item.fieldTitle}
                {item.isRequired ? (
                  <span className={styles.colorRed}> *</span>
                ) : (
                  ''
                )}
              </span>
            ),
            dataIndex: item.fieldId,
            key: item.fieldId,
            ellipsis: !(this.state.fullScreenChild == data.fieldId),
            width: i !== data.childFormFields.length - 1 ? width : '',
            onCell: (record, index) => {
              return {
                onClick: (event) => {
                  data.childFormFields.map((subItem) => {
                    subItem.inputValue = []
                    if (data.inputValue.length > 0) {
                      var valueObj = data.inputValue[index]
                      if (valueObj[subItem.fieldId]) {
                        subItem.inputValue = valueObj[subItem.fieldId]
                      } else {
                        subItem = this._initInputValue(subItem)
                      }
                    } else {
                      subItem = this._initInputValue(subItem)
                    }
                  })
                  data.childFormFields = this.setFormFieldVisibleStatus(
                    data.childFormFields
                  )

                  if (
                    !this.state.currentFormField ||
                    (this.state.currentFormField &&
                      this.state.currentFormField.fieldType !==
                        'FORMREFCustomerField')
                  ) {
                    this.setState(
                      {
                        currentRow: index,
                        currentFormField: data,
                        fullScreenChild: '',
                        preFormField: '',
                        preRowIndex: -1,
                      },
                      () => {
                        this.onDrawerOpenChange()
                      }
                    )
                  } else {
                    if (
                      item.isEditable != false &&
                      (item.fieldType === 'TextField' ||
                        item.fieldType === 'NumberField' ||
                        item.fieldType === 'EmailField' ||
                        item.fieldType === 'MobileField')
                    ) {
                      item.editing = index
                      this.updateFormField(data)
                    } else {
                      var tmpFormField = this.state.currentFormField
                      var preRowIndex = this.state.currentRow
                      this.setState({
                        currentRow: index,
                        currentFormField: data,
                        preFormField: tmpFormField,
                        preRowIndex: preRowIndex,
                      })
                    }
                  }
                },
                onMouseEnter: (event) => {},
              }
            },
            render: (text, record, index) => {
              if (text && item.fieldType === 'TextArea') {
                if (record[item.fieldId].length > 1) {
                  text = record[item.fieldId][0]
                }
              } else if (
                text &&
                typeof text === 'number' &&
                (item.fieldType === 'EquationField' ||
                  item.fieldType === 'StatisticsField' ||
                  item.fieldType === 'NumberField')
              ) {
                if (
                  item.moreSetting &&
                  undefined != item.moreSetting.decimalPoint &&
                  item.moreSetting.decimalPoint != -1
                ) {
                  text = parseFloat(text + '').toFixed(
                    item.moreSetting.decimalPoint
                  )
                  if (text == '0.00' || text == '0.0') {
                    text = 0
                  }
                }
                if (item.isCapital) {
                  text =
                    text + '<br>大写金额（人民币）：' + convertCurrency(text)
                }
              } else if (
                text &&
                (item.fieldType === 'CascadeDropDown' ||
                  item.fieldType === 'CUSTOMIZE_RadioButton')
              ) {
                if (text.length > 1) {
                  var textTmp = ''
                  for (var i = 0; i < text.length; i++) {
                    textTmp += text[i]
                    if (i < text.length - 1) {
                      textTmp += '/'
                    }
                  }
                  text = textTmp
                }
              }

              if (
                item.isEditable != false &&
                (item.fieldType === 'TextField' ||
                  item.fieldType === 'NumberField' ||
                  item.fieldType === 'EmailField' ||
                  item.fieldType === 'MobileField')
              ) {
                if (item.editing === index) {
                  return (
                    <Form.Item style={{ margin: '-3px' }}>
                      <Input
                        defaultValue={text}
                        onPressEnter={(e) => {
                          item.editing = -1
                          this.updateFormField(data)
                        }}
                        onChange={(e) => {
                          data.inputValue[index][item.fieldId] = [
                            e.target.value,
                          ]
                          data.childFormFields.map((subItem) => {
                            if (
                              subItem.fieldType === 'EquationField' &&
                              subItem.moreSetting &&
                              subItem.moreSetting.equation
                            ) {
                              var value = 0
                              try {
                                var equation = _getFormatEquation(
                                  subItem.moreSetting.equation
                                )
                                data.childFormFields.map((sonItem) => {
                                  if (
                                    equation.indexOf(
                                      '${' + sonItem.fieldId + '}'
                                    ) >= 0
                                  ) {
                                    var fieldValue =
                                      data.inputValue[index][sonItem.fieldId]
                                    if (fieldValue != undefined) {
                                      equation = equation.replace(
                                        new RegExp(
                                          '\\${' + sonItem.fieldId + '}',
                                          'g'
                                        ),
                                        parseFloat(fieldValue)
                                      )
                                    }
                                  }
                                })
                                if (equation.indexOf('/(0)') > 0) {
                                  equation = equation.replace(
                                    /\/\(0\)/g,
                                    '/(1)'
                                  )
                                }
                                if (equation.indexOf('*(0)') > 0) {
                                  equation = equation.replace(
                                    /\*\(0\)/g,
                                    '*(1)'
                                  )
                                }
                                value = eval(equation)
                                if (isNaN(value)) {
                                  value = undefined
                                }
                              } catch (err) {
                                value = undefined
                              }
                              if (value != undefined) {
                                if (
                                  subItem.moreSetting &&
                                  undefined !=
                                    subItem.moreSetting.decimalPoint &&
                                  subItem.moreSetting.decimalPoint != -1
                                ) {
                                  value = value.toFixed(
                                    subItem.moreSetting.decimalPoint
                                  )
                                }

                                if (value == '0.00' || value == '0.0') {
                                  value = 0
                                }
                                data.inputValue[index][subItem.fieldId] = [
                                  value,
                                ]
                              }
                            }
                          })
                          data.childFormFields.map((subItem) => {
                            if (
                              subItem.defaultValueType == 4 &&
                              subItem.defaultValue &&
                              item.fieldId != subItem.fieldId
                            ) {
                              data.inputValue[index][subItem.fieldId] =
                                data.inputValue[index][
                                  subItem.defaultValue.substring(
                                    2,
                                    subItem.defaultValue.length - 1
                                  )
                                ]
                            }
                          })
                          this.updateFormField(data)
                        }}
                      />
                    </Form.Item>
                  )
                } else {
                  return (
                    <div
                      contentEditable={false}
                      dangerouslySetInnerHTML={{ __html: text }}
                    ></div>
                  )
                }
              } else {
                return (
                  <div
                    contentEditable={false}
                    dangerouslySetInnerHTML={{ __html: text }}
                  ></div>
                )
              }
            },
          }
          columns.splice(columns.length, 0, column)
        })

        return (
          <div>
            <div className={styles.childFormTable}>
              <Table
                bordered
                pagination={false}
                size="middle"
                columns={columns}
                dataSource={myDataSource}
                scroll={{ x: true }}
              />
            </div>
            {this.state.currentFormField &&
            this.state.currentFormField.fieldType === 'FORMREFCustomerField' ? (
              <div></div>
            ) : (
              <div className={styles.chlidContrl}>
                <div
                  className={styles.addChild}
                  onClick={() => {
                    if (
                      data.inputValue.length === 1 &&
                      data.inputValue[0].example
                    ) {
                      data.childFormFields.map((item) => {
                        item.inputValue = []
                        if (data.inputValue.length > 0) {
                          var valueObj = data.inputValue[0]
                          if (valueObj[item.fieldId]) {
                            item.inputValue = valueObj[item.fieldId]
                          } else {
                            item = this._initInputValue(item)
                          }
                        } else {
                          item = this._initInputValue(item)
                        }
                      })
                      this.setState(
                        { currentRow: 0, currentFormField: data },
                        () => {
                          this.onDrawerOpenChange()
                        }
                      )
                    } else {
                      this.addChildForm(data)
                    }
                  }}
                >
                  <span
                    className={[
                      `${styles.icon_btn}`,
                      `${styles.ic_child_add}`,
                    ].join(' ')}
                  ></span>{' '}
                  添加
                </div>
              </div>
            )}
          </div>
        )
      case 'AccessoryField':
        return (
          <Upload
            multiple="true"
            action={process.env.API_HOST + '/file/upload.api'}
            onChange={(info) => this.onUploadChange(info, data)}
            data={{ authtoken: this.sid }}
            defaultFileList={data.inputValue}
            onDownload={(file) => {
              const url =
                process.env.API_HOST + _getDownloadPath(file.url, file.name)
              const link = document.createElement('a')
              link.href = url
              link.download = file.name
              link.click()
            }}
            onPreview={(file) => {
              if (file && file.type && file.type.indexOf('image/') === 0) {
                Zmage.browsing({
                  src: ALI_OSS_DOWNLOAD + file.url,
                  backdrop: 'rgba(0,0,0,.5)',
                })
              } else {
                previewFileByOW365(file)
              }
            }}
          >
            <Button>
              <UploadOutlined />
            </Button>
          </Upload>
        )
      case 'BusinessField':
        const businessData = []
        data.multipleValue.map((item, index) => {
          businessData.splice(index, 0, item.name)
        })
        return (
          <div
            className={[
              `${styles.choiceField}`,
              data.isReadOnly ? `${styles.readOnly}` : ``,
            ].join(' ')}
          >
            <CheckboxGroup
              value={data.inputValue}
              onChange={(e) => this.onCheckBoxChange(e, data)}
            >
              {businessData.map((item) => (
                <Checkbox
                  disabled={data.isReadOnly}
                  className={styles.choiceFieldItem}
                  key={item}
                  value={item}
                  style={{ width: '50%' }}
                >
                  {item}
                </Checkbox>
              ))}
            </CheckboxGroup>
          </div>
        )
      case 'CascadeDropDown':
        return (
          <Cascader
            options={data.multipleValue}
            value={data.inputValue}
            style={{ width: '100%' }}
            onChange={(value) => {
              data.inputValue = value
              this.updateFormField(data)
            }}
            placeholder="请选择"
          />
        )
      case 'EquationField':
        return inputNumberView
      case 'StatisticsField':
        return inputNumberView
      case 'ImageField':
        return (
          <ul className={styles.impression}>
            {data.inputValue.map((item, index) => {
              return (
                <li className={styles.imageList}>
                  <a
                    className={styles.remove_icon_minus}
                    onClick={() => {
                      data.inputValue.splice(index, 1)
                      this.updateFormField(data)
                    }}
                  ></a>
                  <p className={styles.img}>
                    {isQiyeweixinApp() ? (
                      <img
                        className={[
                          `${styles.image_addIcon}`,
                          `${styles.previewImagesField}`,
                        ].join(' ')}
                        src={
                          process.env.API_HOST +
                          _getDownloadPath(item.url, item.name)
                        }
                        onClick={() => this.previewImage(data.inputValue, item)}
                      ></img>
                    ) : (
                      <Zmage
                        src={ALI_OSS_DOWNLOAD + item.url}
                        backdrop="rgba(0,0,0,.5)"
                        className={[
                          `${styles.image_addIcon}`,
                          `${styles.previewImagesField}`,
                        ].join(' ')}
                      ></Zmage>
                    )}
                  </p>
                </li>
              )
            })}
            {isQiyeweixinApp() ? (
              <div className={styles.add_image_box}>
                <div
                  className={[
                    `${styles.image_addIcon}`,
                    `${styles.disabled}`,
                  ].join(' ')}
                  onClick={() => {
                    this.addImageOnClick(data)
                  }}
                ></div>
              </div>
            ) : (
              <Upload
                multiple="true"
                action={process.env.API_HOST + '/file/upload.api'}
                onChange={(info) => this.onUploadChange(info, data)}
                accept="image/*"
                data={{ authtoken: this.sid }}
                showUploadList={false}
              >
                <div className={styles.add_image_box}>
                  <div
                    className={[
                      `${styles.image_addIcon}`,
                      `${styles.disabled}`,
                    ].join(' ')}
                  ></div>
                </div>
              </Upload>
            )}
          </ul>
        )
      case 'OcrInvoice':
        return (
          <span>
            <ul className={styles.impression}>
              {data.inputValue.map((item, index) => {
                return (
                  <li
                    className={styles.imageList}
                    style={{ borderBottom: 'none', marginTop: '4px' }}
                  >
                    {item.status !== 'done' ? (
                      <p
                        className={styles.img}
                        style={{ textAlign: 'center', paddingTop: 15 }}
                      >
                        <Spin
                          indicator={
                            <LoadingOutlined style={{ fontSize: 24 }} spin />
                          }
                        />
                      </p>
                    ) : (
                      <span>
                        <a
                          className={styles.remove_icon_minus}
                          onClick={() => {
                            data.inputValue.splice(index, 1)
                            if (
                              this.state.removeFileList.indexOf(item.url) < 0
                            ) {
                              this.state.removeFileList.push(item.url)
                              this.setState({
                                removeFileList: this.state.removeFileList,
                              })
                            }
                            this.updateFormField(data)
                          }}
                        ></a>
                        <p className={styles.img}>
                          {typeof item.url === 'string' &&
                          item.url.toLowerCase().endsWith('.pdf') ? (
                            <span>
                              <img
                                className={[
                                  `${styles.image_addIcon}`,
                                  `${styles.previewImagesField}`,
                                ].join(' ')}
                                src={require('../../assets/img/pdf.png')}
                                onClick={() => previewFileByOW365(item)}
                              />
                            </span>
                          ) : isQiyeweixinApp() ? (
                            <img
                              className={[
                                `${styles.image_addIcon}`,
                                `${styles.previewImagesField}`,
                              ].join(' ')}
                              src={
                                process.env.API_HOST +
                                _getDownloadPath(item.url, item.name)
                              }
                              onClick={() =>
                                this.previewImage(data.inputValue, item)
                              }
                            ></img>
                          ) : (
                            <Zmage
                              src={ALI_OSS_DOWNLOAD + item.url}
                              backdrop="rgba(0,0,0,.5)"
                              className={[
                                `${styles.image_addIcon}`,
                                `${styles.previewImagesField}`,
                              ].join(' ')}
                            ></Zmage>
                          )}
                        </p>
                      </span>
                    )}
                  </li>
                )
              })}
              <Upload
                multiple="true"
                action={process.env.API_HOST + '/file/upload.api'}
                onChange={(info) => this.onOcrVatInvoiceChange(info, data)}
                accept="image/*,.pdf"
                data={{ authtoken: this.sid }}
                showUploadList={false}
              >
                <div className={styles.add_image_box}>
                  <div
                    className={[
                      `${styles.image_addIcon}`,
                      `${styles.disabled}`,
                    ].join(' ')}
                  ></div>
                </div>
              </Upload>
            </ul>
            {data.inputValue.map((item, index) => {
              if (item.ocrStatus) {
                return (
                  <InvoiceComponent
                    index={index}
                    invoiceInfo={item.invoiceInfo}
                  ></InvoiceComponent>
                )
              } else {
                return <div></div>
              }
            })}
          </span>
        )
      case 'FORMREFCustomerField':
        var myDataSource = []
        let cols = [
          {
            title: (
              <span
                onClick={() => {
                  if (this.state.fullScreenChild == data.fieldId) {
                    this.setState({ fullScreenChild: '' })
                  } else {
                    this.setState({ fullScreenChild: data.fieldId })
                  }
                }}
                className={
                  this.state.fullScreenChild == data.fieldId
                    ? [
                        `${styles.icon_btn}`,
                        `${styles.ic_child_fullScreen}`,
                      ].join(' ')
                    : [`${styles.icon_btn}`, `${styles.ic_child_normal}`].join(
                        ' '
                      )
                }
              ></span>
            ),
            width: 60,
            dataIndex: 'id',
            key: 'id',
            fixed: 'left',
            align: 'center',
            id: 1,
          },
        ]
        for (var i = 0; i < data.inputValue.length; i++) {
          if (data.inputValue[i].fieldList) {
            data.inputValue[i].fieldList.id = i + 1
            myDataSource.push(data.inputValue[i].fieldList)
          }
        }

        var width = 200
        if (data.childFormFields.length <= 2) {
          width = (100 % data.childFormFields.length) + '%'
        }

        data.childFormFields.map((item, i) => {
          let column = {
            title: item.fieldTitle,
            dataIndex: item.fieldId,
            key: item.fieldId,
            ellipsis: !(this.state.fullScreenChild == data.fieldId),
            width: i !== data.childFormFields.length - 1 ? width : '',
            render: (text, record, index) => {
              text = _formatTDText(text, item, record)
              return (
                <div
                  style={{ overflowX: 'auto' }}
                  contentEditable={false}
                  dangerouslySetInnerHTML={{ __html: text }}
                ></div>
              )
            },
          }
          cols.splice(cols.length, 0, column)
        })

        return (
          <div>
            {data.inputValue.length > 0 ? (
              <div>
                <div className={styles.childFormTable}>
                  <Table
                    bordered
                    pagination={false}
                    size="middle"
                    columns={cols}
                    dataSource={myDataSource}
                    scroll={{ x: true }}
                    onRow={(record, index) => {
                      return {
                        onClick: (event) => {
                          data.childFormFields.map((item) => {
                            item.inputValue = ['']
                            if (data.inputValue.length > 0) {
                              var valueObj = data.inputValue[index].fieldList
                              if (valueObj[item.fieldId]) {
                                item.inputValue = valueObj[item.fieldId]
                              }
                            }
                          })
                          data.childFormFields = this.setFormFieldVisibleStatus(
                            data.childFormFields
                          )
                          this.setState(
                            {
                              currentRow: index,
                              currentFormField: data,
                              fullScreenChild: '',
                            },
                            () => {
                              this.onDrawerOpenChange()
                            }
                          )
                        },
                      }
                    }}
                  />
                </div>
              </div>
            ) : (
              ''
            )}
            <div
              className={styles.childFormItemAdd}
              onClick={(e) => {
                if (data.isReadOnly) {
                  Toast.info('只读字段', 1)
                  return
                }
                e.preventDefault()
                this.setState(
                  {
                    selectedData: data.inputValue,
                    selectedExtra: {
                      type: 100,
                      data,
                      maxLength: data.maxLength,
                      definitionId: this.state.definitionId,
                      fieldId: data.fieldId,
                    },
                  },
                  () => setTimeout(this.selectFormDataModal.showModal(), 20)
                )
              }}
            >
              选择数据
            </div>
          </div>
        )
      case 'CUSTOMIZE_RadioButton':
        if (data.isCascadeDropDown) {
          return (
            <Cascader
              style={{ width: '100%' }}
              options={data.multipleValue}
              defaultValue={data.inputValue}
              value={data.inputValue}
              fieldNames={{
                label: 'name',
                value: 'name',
                children: 'children',
              }}
              onChange={(value) => {
                data.inputValue = value
                this.updateFormField(data)
              }}
              placeholder="请选择"
            />
          )
        } else {
          return (
            <Radio.Group
              value={data.inputValue[0]}
              className={[
                `${styles.choiceField}`,
                data.isReadOnly ? `${styles.readOnly}` : ``,
              ].join(' ')}
              onChange={(e) => this.onCommonChange(e, data)}
            >
              {data.multipleValue.map((item, index) => (
                <div
                  key={index}
                  className={styles.choiceFieldItem}
                  style={{ width: 100 / data.showType + '%' }}
                >
                  <Radio
                    disabled={data.isReadOnly}
                    value={item.name}
                    style={{
                      display: 'block',
                      width: '100%',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'normal',
                      wordWrap: 'break-word',
                    }}
                  >
                    {item.name}
                  </Radio>
                </div>
              ))}
            </Radio.Group>
          )
        }
      default:
        return <span>无法识别</span>
    }
  }

  render() {
    if (this.state.hasError) {
      return <h1>出错了...</h1>
    }
    return (
      <div className="wrap">
        {this.state.isLoading ? (
          <span>
            <Spin
              tip={'享受生活，享受阳光'}
              style={{ width: '100%', marginTop: '40%' }}
              size="large"
            />
          </span>
        ) : (
          <Drawer
            className="my-drawer"
            style={{
              display: 'contents',
              minHeight: document.documentElement.clientHeight,
              width: this.state.fullScreenChild ? 'auto' : '',
            }}
            sidebar={this.renderChildFormDetail()}
            position="right"
            touch={false}
            contentStyle={{ width: this.state.fullScreenChild ? 'auto' : '' }}
            open={this.state.childFormDrawerOpen}
          >
            <div
              className={styles.formTitleBox}
              ref={(ref) => {
                this.titleBox = ref
              }}
            >
              {this.state.limitStr && this.state.limitStr.length > 0 ? (
                <div className={styles.limit_time_tips}>
                  表单未到可填写时间。{this.state.limitStr}
                </div>
              ) : (
                ''
              )}
              <div className={styles.formTitleRead}>
                <span className={styles.ctitle}>
                  {this.state.toaForm.formTitle}
                </span>
              </div>
            </div>
            <div
              className={styles.wrap}
              style={{ top: this.state.mTop, paddingBottom: 10 }}
            >
              <div className={styles.formBg}>
                <div className={styles.formDetailBox} id="formDetailBox">
                  <div
                    className={styles.formDetailContent}
                    style={{
                      minHeight: 92,
                      height: this.state.formDetailShow ? 'auto' : '92px',
                    }}
                  >
                    <p
                      id="content"
                      dangerouslySetInnerHTML={{
                        __html: this.state.toaForm.formDesc,
                      }}
                    ></p>
                  </div>
                  <div className={styles.formDetailContentBlur}></div>
                  <div
                    className={styles.formDetailContentToggle}
                    onClick={this.formDetailToggle}
                  >
                    {this.state.formDetailShow ? '收起' : '展开显示全部'}
                    <span className={styles.toggleDown}></span>
                  </div>
                </div>
              </div>
              {this.state.fileList && this.state.fileList.length > 0 ? (
                <div
                  className={[
                    `${styles.titleFile}`,
                    `${styles.fileListLen}`,
                  ].join(' ')}
                >
                  <div className={styles.fileTitle}>
                    附件({this.state.fileList.length})
                  </div>
                  {this.state.fileList.map((item) => {
                    return (
                      <div className={styles.fujian}>
                        <div className={styles.fujian_text}>
                          <p
                            className={styles.name}
                            onClick={() => {
                              if (
                                item &&
                                item.type &&
                                item.type.indexOf('image/') === 0
                              ) {
                                Zmage.browsing({
                                  src: ALI_OSS_DOWNLOAD + item.url,
                                  backdrop: 'rgba(0,0,0,.5)',
                                })
                              } else {
                                previewFileByOW365(item)
                              }
                            }}
                          >
                            {item.name}
                          </p>
                          <p className={styles.fujian_size}>
                            {item.size < 100
                              ? item.size.toFixed(0) + ' bytes'
                              : item.size < 102400
                              ? (item.size / 1024).toFixed(2) + ' K'
                              : (item.size / (1024 * 1024)).toFixed(2) + ' M'}
                          </p>
                        </div>
                        <div
                          className={styles.flex_iconp}
                          onClick={() => {
                            window.open(
                              process.env.API_HOST +
                                _getDownloadPath(item.url, item.name)
                            )
                          }}
                        >
                          <i
                            className={[
                              `${styles.iocnType}`,
                              `${styles.icon_download}`,
                            ].join(' ')}
                          ></i>
                        </div>
                      </div>
                    )
                  })}
                </div>
              ) : (
                ''
              )}
              <Form
                className={styles.formContent}
                validateMessages={validateMessages}
                ref={this.mainFormRef}
              >
                {this.state.formFields.map((item) =>
                  item.isVisible ? (
                    <div className={styles.formGroup} key={item.fieldId}>
                      {item.fieldType !== 'SectionBreak' ? (
                        <div className={styles.formLabel}>
                          <label className={styles.controlLabel}>
                            {item.fieldTitle}
                          </label>
                          {item.isRequired ? (
                            <span className={styles.colorRed}> *</span>
                          ) : (
                            ''
                          )}
                          {item.tip ? (
                            <div className={styles.fieldNotes}>
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: item.tipMedium,
                                }}
                              ></p>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      ) : (
                        ''
                      )}
                      <div className={styles.fieldContent} id={item.fieldId}>
                        <div
                          className={
                            this.state.fullScreenChild == item.fieldId
                              ? `${styles.childFormFullScreen}`
                              : ``
                          }
                        >
                          {this.renderFormField(item)}
                        </div>
                      </div>
                      <div className={styles.helpBlock}></div>
                    </div>
                  ) : (
                    ''
                  )
                )}
              </Form>
              {this.state.formSetting &&
              this.state.formSetting.submitcfg &&
              this.state.formSetting.submitcfg.transactorCCEnable === '0' ? (
                <span></span>
              ) : (
                <div className={styles.userSelectChargeView}>
                  <div className={styles.userSelectTop}>
                    <div className={styles.userCellView}>
                      <p className={styles.title}>相关人</p>
                    </div>
                    <div className={styles.userCellFr}>
                      加载上次
                      <div className={styles.userCellSwitch}>
                        <Switch
                          onChange={(checked) => {
                            if (checked) {
                              this.setState({
                                transactorCC: [].concat(this.state.lastCC),
                              })
                            } else {
                              this.setState({ transactorCC: [] })
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={styles.userSelectWap}>
                    <div className={styles.userSelectListView}>
                      {this.state.transactorCC.map((item, index) => (
                        <div key={index} className={styles.userContentWrap}>
                          <div className={styles.userSelectView}>
                            <a
                              className={styles.remove_icon}
                              onClick={() => {
                                this.state.transactorCC.splice(index, 1)
                                this.setState({
                                  transactorCC: this.state.transactorCC,
                                })
                              }}
                            ></a>
                            <p className={styles.img}>
                              <img
                                className={styles.user_select_img}
                                src={item.avatar}
                              ></img>
                            </p>
                            <p className={styles.userInfo_name}>{item.name}</p>
                          </div>
                        </div>
                      ))}
                      <div className={styles.userContentWrap}>
                        <div
                          onClick={(e) => {
                            e.preventDefault()
                            this.setState(
                              {
                                selectedData: this.state.transactorCC,
                                selectedExtra: { type: 1 },
                              },
                              () =>
                                setTimeout(
                                  this.selectMemberModal.showModal(),
                                  20
                                )
                            )
                          }}
                          className={styles.userSelectAdd}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className={styles.bottomIndex}>
                <div className={styles.btn_tab}>
                  <Button
                    style={{ flex: 1, height: 44, marginRight: 15 }}
                    disabled={this.state.submittingFormData}
                    onClick={() => this.saveFormData(-2)}
                  >
                    保存为草稿
                  </Button>
                  <Button
                    style={{ flex: 1, height: 44 }}
                    loading={this.state.submittingFormData}
                    disabled={
                      this.state.limitStr && this.state.limitStr.length > 0
                    }
                    type="primary"
                    onClick={() => this.saveFormData(2)}
                  >
                    立即提交
                  </Button>
                </div>
              </div>
              <div className={styles.openFooterContent}>
                <p>
                  如果你还没有确定现在立即发布，可以保存为草稿，之后可以再次编辑。
                </p>
              </div>

              <Modal
                popup
                visible={this.state.selectDepart}
                animationType="slide-up"
                onClose={() => {}}
                afterClose={() => {}}
              >
                <List
                  renderHeader={() => <div>选择归属部门</div>}
                  className="popup-list"
                >
                  <Radio.Group
                    style={{ width: '100%' }}
                    onChange={(e) =>
                      this.setState({ userDepart: e.target.value })
                    }
                    defaultValue={this.state.userDepart}
                  >
                    {this.state.userDepartList.map((item, index) => {
                      return (
                        <List.Item key={index}>
                          <Radio value={item.id}>{item.name}</Radio>
                        </List.Item>
                      )
                    })}
                  </Radio.Group>
                  <List.Item>
                    <div
                      className="addForm"
                      onClick={() => {
                        this.setState({ selectDepart: false })
                        this.saveFormData(this.state.actionType)
                      }}
                    >
                      确定
                    </div>
                  </List.Item>
                </List>
              </Modal>

              <SelectMember
                triggerRef={this.bindSelectMemberRef}
                callback={this.updateSelectedData}
                selectedData={this.state.selectedData}
                sid={this.sid}
                extra={this.state.selectedExtra}
              />
              <SelectFormData
                triggerRef={this.bindSelectFormDataRef}
                callback={this.updateSelectedData}
                selectedData={this.state.selectedData}
                sid={this.sid}
                extra={this.state.selectedExtra}
              />
              <SelectSourceData
                triggerRef={this.bindSelectSourceDataRef}
                callback={this.updateSelectedData}
                selectedData={this.state.selectedData}
                sid={this.sid}
                extra={this.state.selectedExtra}
              />
            </div>
          </Drawer>
        )}
      </div>
    )
  }
}

export default withCookies(FormMainPage)

